<template>
	<div class="flex flex-grow">
		<div class="md:gap-1 items-baseline w-full">
			<div class="flex text-left my-6 w-full" v-for="pdfAppendix in pdfAppendixes" :key="pdfAppendix.id">
				<div class="w-1/2" :class="pdfAppendix.isStored ? 'cursor-pointer' : ''" @click="pdfAppendix.isStored ? downloadFile(pdfAppendix.id) : ''">
					{{ pdfAppendix.name }}
				</div>
				<div class="px-6 text-right">
					<DocumentFileUploader :instant-upload="false" @input="uploadDocument($event, pdfAppendix)" accept="application/pdf">
						<font-awesome-icon :icon="['fas', 'upload']" class="cursor-pointer" />
					</DocumentFileUploader>
				</div>
				<div class="text-right" v-if="pdfAppendix.isStored">
					<font-awesome-icon :icon="['fas', 'check']" class="pb-1" style="font-size: 20px" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DocumentFileUploader from '@/components/forms/inputs/DocumentFileUploader.vue';
import PdfFormAppendixRepository from '@/api/repositories/PdfFormAppendixRepository';

export default {
	components: { DocumentFileUploader },
	name: 'OnboardingCompanyTOCForm',
	props: {
		value: {},
	},
	data() {
		return {
			isLoading: false,
			pdfAppendixes: [],
			changedAppendix: { base64Document: null, pdfAppendix: null },
		};
	},
	mounted() {
		this.isLoading = true;
		this.getPdfAppendixes();
	},
	methods: {
		getPdfAppendixes() {
			new PdfFormAppendixRepository()
				.getAllAppendixes()
				.then(response => {
					this.pdfAppendixes = response.data.data;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		getSuccessMessage(type) {
			switch (type) {
				case 'gtc_repair_offer':
					return this.$t('gtc_upload_successful', { type: 'Reparatur-Auftrag' }).toString();
				case 'dunning_covering_note':
					return this.$t('dunning_upload_successful').toString();
			}
		},
		getExplanationMessage(type) {
			switch (type) {
				case 'gtc_repair_offer':
					return this.$t('gtc_explanation', { type: 'Reparatur-Auftrag' }).toString();
				case 'dunning_covering_note':
					return this.$t('dunning_explanation').toString();
			}
		},
		getData() {
			return this.pdfAppendixes;
		},
		downloadFile(id) {
			new PdfFormAppendixRepository().getAppendixFile(id).then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' });
				const name = response.headers['content-disposition'].split('filename=')[1];
				if (this.isAppContainer) {
					const reader = new FileReader();
					reader.onload = function() {
						const arrayBuffer = this.result;
						// convert the ArrayBuffer to a comma-separated string
						const dataString = new Uint8Array(arrayBuffer).join(',');
						const messageData = {
							fileName: name,
							data: dataString,
						};
						// send the data to Swift
						window.webkit.messageHandlers.pdfHandler.postMessage(JSON.stringify(messageData));
					};
					reader.readAsArrayBuffer(blob);
				} else {
					const resolvingUrl = URL.createObjectURL(blob) + '#toolbar=1&navpanes=0&scrollbar=0';
					const viewerUrl = `/blobviewer?blobUrl=${encodeURIComponent(resolvingUrl)}&title=${encodeURIComponent(name)}`;

					setTimeout(function() {
						window.open(viewerUrl, '_blank');
						window.URL.revokeObjectURL(viewerUrl);
					}, 200);
				}
			});
		},
		uploadDocument(event, appendix) {
			if (event) {
				appendix.isEnabled = true;
			}
			new PdfFormAppendixRepository()
				.updateAppendix(appendix.id, { isEnabled: appendix.isEnabled, pdfAppendix: event })
				.then(response => {
					this.getSuccessMessage();
					this.getPdfAppendixes();
				})
				.catch(e => {
					this.$swal(this.$t('general.error').toString(), this.$t('gtc_upload_error').toString(), 'error');
				});
		},
	},
};
</script>
